import { domainsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewDomain = (state = initialState, action) => {
  switch (action.type) {
    case domainsConstants.VIEW_DOMAIN_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case domainsConstants.VIEW_DOMAIN_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case domainsConstants.VIEW_DOMAIN_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case domainsConstants.VIEW_DOMAIN_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
